import React from "react";
import "./styles/mobilebar.css";
import { NavLink } from "react-router-dom";
import { IoMdClose } from "react-icons/io";

const MobileBar = ({ open, setOpen, data = [] }) => {
  console.log(open);
  return (
    <div
      style={{
        height: open ? "530px" : "0px",
      }}
      className="mobile-bar-container"
    >
      <div className="mobile-logo">
        <img src="images/logo.svg" alt="Logo" />
        <IoMdClose color="#fff" size={38} onClick={() => {setOpen(false);console.log("click")}} className="mobile-close" />
        </div>
      <div className="mobile-bar-links">
        {data.map((item, index) => {
          return (
            <>
              {item.id !== 3 ? (
                <NavLink
                  className={({ isActive, isPending }) =>
                    isPending ? "links" : isActive ? "active-link" : "links"
                  }
                  onClick={() => {setOpen(false); console.log("click")}}
                  to={item.path}
                >
                  {item.name}
                </NavLink>
              ) : (
                <button
                  className="links integrate-header-btn"
                  onClick={() => {
                    item.id === 3 &&
                      window.open("https://prorewards.gitbook.io/real-opinion");
                    setOpen(false);
                  }}
                >
                  {item.name}
                </button>
              )}
              <div className="separator"></div>
            </>
          );
        })}
      </div>
      <div className="mobile-login-header">
        <button
          className="btn-primary"
          onClick={() => {
            window.open("https://publisher.realopinions.ai/login");
          }}
        >
          Login
        </button>
        <button
          onClick={() => {
            window.open("https://publisher.realopinions.ai/register");
          }}
          className="btn-primary"
        >
          Register
        </button>
      </div>
    </div>
  );
};

export default MobileBar;
